import * as React from "react";
import { connect } from "react-redux";
import { mapDispatchToProps } from "../../redux/actions";
import "../../css/FactoryRequestLockedModal.scss";

interface IProps {
  updateRedux: any;
  reduxModals: any;
}

interface IState {}

class ProjectInReleaseMode extends React.Component<IProps, IState> {
  public state: IState = {};

  public render() {
    const isCopyUnit = this.props.reduxModals.modalData?.isCopyUnit === true;

    return (
      <div className="factory-request-overlay">
        <div className="factory-request-modal">
          <button
            className="factory-request-close"
            onClick={() => this.userResponse("cancel")}
            type="button"
          >
            &times;
          </button>

          <div className="factory-request-header">
            <div className="factory-request-lock"></div>
            <h2>Please Note:</h2>
          </div>

          <div className="factory-request-content">
            {isCopyUnit ? (
              <>
                <p>
                  This unit cannot be copied to this job because a Factory Release Request has been submitted to
                  Innovent Engineering.
                </p>
                <p>
                  As a result, new units can no longer be added in SpecMate.
                </p>
                <p>
                  You can view the status of the Factory Release Request.
                </p>
              </>
            ) : (
              <>
                <p>
                  This job is locked because a Factory Release Request has been submitted to
                  Innovent Engineering.
                </p>
                <p>
                  As a result, new units can no longer be created in SpecMate.
                </p>
                <p>
                  You can view the status of the Factory Release Request.
                </p>
              </>
            )}
          </div>

          <div className="factory-request-divider" />

          <div className="factory-request-footer">
            <button
              className="factory-request-button"
              onClick={() => this.userResponse("ok")}
              type="button"
            >
              <span className="factory-request-button-icon"></span>
              Go to Factory Request
            </button>
          </div>
        </div>
      </div>
    );
  }

  private userResponse(response: string) {
    const projectReleaseResponse = {
      response,
      projectId: this.props.reduxModals.modalData?.projectId,
      unitId: this.props.reduxModals.modalData?.unitId
    };
    this.props.updateRedux("UPDATE_MODALS", {
      showModal: false,
      userResponse: projectReleaseResponse
    });
  }
}

function mapStateToProps(state: any) {
  return {
    reduxModals: state.reduxModals
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectInReleaseMode);
